import { Modal } from '@iziwork/design-system';
import { FC } from 'react';

import { useApplyFormContext, useTranslation } from '~/hooks';

export const ApplyStartHeader: FC = () => {
  const { t } = useTranslation();
  const { applyType } = useApplyFormContext();

  const title = t(`apply.${applyType === 'jobOffer' ? 'title_job_offer_apply' : 'title_free_apply'}`);

  return <Modal.Header title={title} subtitle={t('apply.subtitle_email_to_identify')} />;
};
